import SonnerToastService from './sonner-toast.service';

export default {
    name: 'SonnerToastService',
    definition: SonnerToastService
};
